<template>
  <div>
    <v-btn color="error" persistent @click.native.stop.prevent="toggleModal">
      Delete Account
    </v-btn>
    <v-dialog v-model="isModalOpen" max-width="630px">
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Delete Account</v-toolbar-title>
      </v-toolbar>
      <v-card tile class="modal-content-container">
        <v-card-title>
          <span class="body-heading-small">You are about to delete the account</span>
        </v-card-title>
        <v-card-text>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>This will remove:</v-list-item-title>
              <v-list-item-subtitle class="font-weight-bold">
                - all points of this account
              </v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-bold">
                - all quests related to this account
              </v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-bold">
                - all child accounts
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <p>
                Your account will be suspended immediately and can be fully restored for
                <span class="font-weight-bold">6 months</span>
                simply by logging back in. After
                <span class="font-weight-bold">6 months</span>, it will be permanently deleted and
                <span class="font-weight-bold">CANNOT</span>
                be undone.
              </p>
            </v-list-item-content>
          </v-list-item>
          <v-row class="px-0 justify-space-between">
            <v-btn color="error" class="modal-btn" @click="deleteAccount">Delete</v-btn>
            <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Cancel</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "DeleteAccountModal",

    data() {
      return {
        isModalOpen: false,
      };
    },

    props: {
      accountId: {
        required: true,
      },
      userType: {
        required: true,
      },
    },

    methods: {
      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
      },

      deleteAccount() {
        //TODO: integrate delete account api
        this.$store.commit("setLoadingStatus", true);

        if (this.userType === "child") {
          this.$http
            .delete(`/children/${this.accountId}`)
            .then((response) => {
              this.$store.commit("setLoadingStatus", false);
              this.$router.push({ name: "ParentDashboard" });
            })
            .catch(() => {
              this.$store.commit("setError", {
                message: "Failed to delete kid account",
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        }

        if (this.userType === "parent") {
          this.$http
            .delete("/parents")
            .then((response) => {
              this.$store.commit("setLoadingStatus", false);
              this.$router.push({ name: "Logout" });
            })
            .catch(() => {
              this.$store.commit("setError", {
                message: "Failed to delete user account",
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/DeleteAccountModal.vue